
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import XButton from 'vux/src/components/x-button/index.vue'

import { commonApi } from '@/common/index'
import { mapState } from 'vuex'
import noData from '@/common/components/noData/index.vue'

export default {
name: 'lockAmountDetail',
props: {
showDepositList: {
type: Boolean,
default: false
},
showDiscountsList: {
type: Boolean,
default: false
},
depositList: {
type: Array,
default: () => [],
},
discountsList: {
type: Array,
default: () => [],
}
},
computed: {
...mapState({
UUID: state => state.UUID
})
},
components: {
noData,
XButton,
Flexbox,
FlexboxItem
},
data() {
return {}
},
methods: {

selfUnlockAmount(lockType,id) {
commonApi.HOMEAFTER.selfUnlockAmount({ UUID: this.UUID, lockType, id })
.then(data=>{
this.$vux.toast.show({
text: this.$t('mine').lockAmount.loackItem.unlocked,
type: 'success'
});
this.$emit('refreshList')
})
.catch(err=>{
this.$vux.toast.show({
text: err,
type: 'warn'
});
})
},
filterPlatform(status) {
if (this.$parent.$parent.allPlatform.length > 0) {
const s = this.$parent.$parent.allPlatform[0].filter((item) => (item.value === status))
return s.length > 0 ? s[0]['name'] : ''
} else {
return ''
}
}
}
};



// WEBPACK FOOTER //
// ./src/pages/build800/components/base/lockAmountDetail.vue